module.exports = __webpack_public_path__ + "img/img26.1be6dade.png";